import { HeaderWcp } from '@intigral/ui';
import { Button, Text, FlexWrapper } from '@intigral/shared';
import { __ } from '../translations';
import withPresetWidth from '@intigral/shared/components/hocs/withPresetWidth/withPresetWidth';
import { LanguageToggle } from '../features/header/components/elements';
import { ROUTE_CONSTANT } from '@libs/constants';
import { useProfileExit } from '../hooks/useProfileExit';

const FlexWidth = withPresetWidth(FlexWrapper);

export const ExitKidPage: React.FC = () => {
    const { exitKidsMode } = useProfileExit();

    return (
        <>
            <HeaderWcp
                logoProps={{
                    homeUrl: '/',
                    title: 'STC logo',
                    logoSrc: 'images/big-logo.svg',
                    LinkComponent: 'a',
                }}
                staticChildren={<LanguageToggle navigateTo={ROUTE_CONSTANT.EXIT_KID} />}
            />
            <div className="container" style={{ paddingBottom: 'calc(var(--step) * 18)' }}>
                <Text as="h2" variant="h2" margin="4x" alignment="center">
                    {__('consent_exit_kid_heading')}
                </Text>
                <FlexWidth direction="column" gap="4x" alignItems="center" presetWidth="small">
                    <Text as="span" size="14" style={{ color: 'var(--white-30)' }}>
                        {__('consent_exit_kid_subheading')}
                    </Text>
                    <Button onClick={() => exitKidsMode()} data-test="kids-mode-exit-confirm-btn">
                        {__(`consent_exit_kid_button_text`)}
                    </Button>
                </FlexWidth>
            </div>
        </>
    );
};
